import { render, staticRenderFns } from "./ComputerList.vue?vue&type=template&id=344aa2bb"
import script from "./ComputerList.vue?vue&type=script&lang=js"
export * from "./ComputerList.vue?vue&type=script&lang=js"
import style0 from "./ComputerList.vue?vue&type=style&index=0&id=344aa2bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports